type FlickingPluginsModule = typeof import('@egjs/flicking-plugins')

let pluginsModule: FlickingPluginsModule | null = null

async function loadFlickingPluginsModule(): Promise<FlickingPluginsModule> {
  if (!pluginsModule) {
    const mod = await import('@egjs/flicking-plugins')
    pluginsModule = (mod.default ?? mod) as FlickingPluginsModule
  }

  return pluginsModule
}

export async function getFlickingPlugin<K extends keyof FlickingPluginsModule>(
  name: K,
): Promise<FlickingPluginsModule[K]> {
  const plugins = await loadFlickingPluginsModule()
  return plugins[name]
}
